import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';

export default ({ sx }: { sx?: SxProps<Theme> }) => {
  return (
    <Stack
      sx={{
        margin: '10px',
        ...sx
      }}
    >
      <CircularProgress />
    </Stack>
  );
};
